/* eslint-disable import/prefer-default-export */
import moment from 'moment';

/**
 * Deep copies a JSON object
 * @param {object} object - Object to copy
 * @return {object} - Cloned object
 */
export const deepCopyJsonObject = (object) => JSON.parse(JSON.stringify(object));

/**
 * Generates a load details object with an updated activity (comment added)
 * can be used for optimistic responses.
 * @param {object} currentState - Current load details state
 * @param {*} commentPayload - Comment payload you want to optimistically set in load details
 * @param {*} user - Application current user
 * @return {object} - Optimistic load details object
 */
export default function generateCommentOnEventOptimisticResponse(currentState, commentPayload, user) {
  const activity = deepCopyJsonObject(currentState.activity);
  const changedActivity = activity.find((x) => x.eventId === commentPayload.eventId);
  if (!changedActivity.comments) {
    changedActivity.comments = [];
  }
  changedActivity.comments.push({
    ...commentPayload,
    author: {
      name: user.username,
      author: user.emailaddress,
    },
    createdAt: moment().format(),
    commentId: '',
  });

  return { ...currentState, activity };
}
